import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { GraphData } from '../../util/calculation.interface';

/**
 * The shape the Lambda's mapper.py expects. Rates are ratios (0.24), not percentages.
 * Each override is null unless the advisor changed that rate from its TXS default — BXR
 * derives the rate itself when the override is absent. 0 is a real override, not "unset".
 */
export interface BetrCalculateRequest {
  accountType: string;
  conversionTaxes: string;
  rothConvAmt: number;
  iraBasis: number;
  annualReturn: number;
  dividendYield: number;
  cashYield: number;
  dividendTaxRate: number;
  gainTaxRate: number;
  income: number;
  filingStatus: string;
  state: string;
  localTaxRate: number;
  futureIncome: number;
  futureFilingStatus: string;
  futureState: string;
  futureLocalTaxRate: number;
  currentFederalOverride: number | null;
  currentStateOverride: number | null;
  futureFederalOverride: number | null;
  futureStateOverride: number | null;
}

@Injectable({
  providedIn: 'root',
})
export class BetrCalculationService {
  private readonly BETR_URL = environment.betrCalculateUrl;

  constructor(private http: HttpClient) {}

  async calculate(request: BetrCalculateRequest): Promise<GraphData> {
    return firstValueFrom(this.http.post<GraphData>(this.BETR_URL, request));
  }
}
